export const origensReducer = (state = {loading:true,result:null,origens:null,origen:null} , action) => {
    switch (action.type) {
        case 'ORIGEN_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'ORIGENS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                origens: action.payload
            }
        case 'ORIGEN_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                origen: action.payload
            }
        case 'ORIGEN_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                origens: state.origens.filter(origen => origen._id !== action.payload.idOrigen)
            }
        case 'ORIGEN_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'ORIGEN_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'ORIGEN_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'ORIGEN_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

